import axios from "axios";
var qs = require("qs");

let base = "",
  upPath = "";
if (process.env.NODE_ENV === "development") {
  //本地开发环境
  base = "/api";
  upPath = "/";
} else {
  base = "";
  upPath = "";
}
// else if (process.env.NODE_ENV === 'testing') {
//   //线上测试环境
//   base = 'http://admin-test-api.lienjang.cn'
//   upPath = ''
// } else if (process.env.NODE_ENV === 'production') {
//   //线上正式环境
//   // base = 'http://test-api.renhe.cn';
//   base = 'http://admin-api.lienjang.cn'
//   // base = 'http://47.121.127.235:1819'
//   // base = 'http://crm-api.lienjang.cn';
//   // base = 'http://admin-api.lienjang.top';

//   upPath = ''
// }

export const BASE = base;
export const uploadPath = upPath;

/**=====================================================================================
 * 公公方法
 *======================================================================================*/
export const COMMON = {
  /**
   * [description] 判断是否具有访问 id 模块的权限
   * @param  {[type]} id [description]
   * @return {[type]}    [description]
   */
  getPermissionStatus: (id) => {
    let ids = localStorage.getItem("ids") || [];

    if (ids.indexOf(id) > -1) {
      return true;
    }

    return false;
  },
  /**
   * [description] 毫秒数转成需要的格式
   * @param  {[type]} type      [description] 1: yyyy-mm-dd. 2: yyyy-mm-dd hh:mm:ss 3:yyyy-mm-dd hh:mm
   * @param  {[type]} separator [description] 分隔符
   * @param  {[type]} time      [description] 毫秒数
   * @return {[type]}           [description]
   */
  formatDate: (type, separator, time) => {
    let formatdate = new Date(time),
      year = formatdate.getFullYear(),
      month = formatdate.getMonth(),
      day = formatdate.getDate(),
      hours = formatdate.getHours(),
      minute = formatdate.getMinutes(),
      second = formatdate.getSeconds();

    month = month + 1 < 10 ? "0" + (month + 1) : month + 1;
    day = day < 10 ? "0" + day : day;
    hours = hours < 10 ? "0" + hours : hours;
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;

    if (type == 1) {
      return year + separator + month + separator + day;
    } else if (type == 2) {
      return (
        year +
        separator +
        month +
        separator +
        day +
        " " +
        hours +
        ":" +
        minute +
        ":" +
        second
      );
    } else if (type == 3) {
      return (
        year + separator + month + separator + day + " " + hours + ":" + minute
      );
    } else {
      return time;
    }
  },
  /**
   * [getNowWeek description] 获取本周
   * @return {[type]} [description]
   */
  getNowWeek: function () {
    let now = new Date(),
      dayOfWeek = now.getDay();

    if (dayOfWeek == 0) {
      dayOfWeek = 6;
    } else {
      dayOfWeek -= 1;
    }

    return [
      COMMON.formatDate(1, "-", now.getTime() - dayOfWeek * 24 * 3600 * 1000),
      COMMON.formatDate(1, "-", now.getTime()),
    ];
  },
  /**
   * [getNowMonth description] 获取本月
   * @return {[type]} [description]
   */
  getNowMonth: function () {
    let now = new Date(),
      month = now.getMonth(),
      year = now.getFullYear();

    return [
      COMMON.formatDate(1, "-", new Date(year, month, 1)),
      COMMON.formatDate(1, "-", now.getTime()),
    ];
  },
  /**
   * [getMonthDays description] 获取某月份的天数
   * @param  {[type]} myMonth [description]
   * @return {[type]}         [description]
   */
  getMonthDays(month) {
    let now = new Date(),
      year = now.getFullYear();

    let startDate = new Date(year, month, 1),
      endDate = new Date(year, month + 1, 1);

    return (endDate - startDate) / (1000 * 60 * 60 * 24);
  },
  /**
   * [formatterDateRange description] 获取起始日期的0点毫秒数、结束日期的24点毫秒数
   * @param  {[type]} dateStart [description]
   * @param  {[type]} dateEnd   [description]
   * @return {[type]}           [description]
   */
  formatterDateRange: function (dateStart, dateEnd) {
    let startDateTime = new Date(
        new Date(dateStart).toLocaleDateString(),
      ).getTime(),
      endDateTime =
        new Date(new Date(dateEnd).toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1;

    return [startDateTime, endDateTime];
  },
  /**
   * [getDay description] 获取近几日的日期
   * @param  {[Number]} day [description] 近几日 例如近7日  传-7
   * @return {[String]}           [description] 近几日的那一日期
   */
  getDay: function (day) {
    if (day < 0) {
      day = day + 1;
    }
    let today = new Date();
    let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

    today.setTime(targetday_milliseconds);

    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();

    tMonth = COMMON.doHandleAddZero(tMonth + 1);
    tDate = COMMON.doHandleAddZero(tDate);

    return tYear + "-" + tMonth + "-" + tDate;
  },
  // 根据生日获取年龄
  getAge: function (birthday) {
    const today = new Date();
    const birthDate = new Date(birthday);
    let age = today.getFullYear() - birthDate.getFullYear();

    // 检查月份和日期是否已过生日
    // const monthDiff = today.getMonth() - birthDate.getMonth();
    // if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    //     age--;
    // }
    return age;
  },
  /**
   * [doHandleMonth description] 月份、日期补0
   * @param  {[Number]} value [description] 日期或月份
   * @return {[String]}           [description] 是否补0后的日期和月份
   */
  doHandleAddZero: function (value) {
    let val = value;

    if (value.toString().length == 1) {
      val = "0" + value;
    }

    return val;
  },
  // 大于等于0的数字
  isNonNegativeNumber(value) {
    if (typeof value === "string") value = value.trim();
    const num = Number(value);
    return Number.isFinite(num) && num >= 0;
  },
};
function getToken() {
  const crmUserToken = localStorage.getItem("crmUserToken");
  const crmUserSid = localStorage.getItem("crmUserSid");
  if (!crmUserToken || !crmUserSid) {
    return "";
  }
  return crmUserToken + "-" + crmUserSid;
}

function getHeader() {
  return {
    "content-type": "application/x-www-form-urlencoded",
    ...(getToken() ? { Authorization: getToken() } : {}),
  };
}
function getUtfHeader() {
  return {
    "content-type": "application/json;charset=UTF-8",
    ...(getToken() ? { Authorization: getToken() } : {}),
  };
}
function getPDFHeader() {
  return {
    "content-type": "application/pdf;charset=utf-8",
    ...(getToken() ? { Authorization: getToken() } : {}),
  };
}

/**=====================================================================================
 * 商品管理
 *======================================================================================*/
// 商品 — 列表
export const commodityList = (params) => {
  return axios
    .post(`${base}/commodity/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 列表 - 规格明细
export const commodityListSku = (params) => {
  return axios
    .post(`${base}/commodity/getCommoditySkuVo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 列表 - 保存价格或库存
export const commodityListUpdateSku = (params) => {
  return axios
    .post(`${base}/commodity/updateSku`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 上下架、删除
export const commodityUpdateStatus = (params) => {
  return axios
    .post(`${base}/commodity/updateStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 规格列表
export const commoditySpecificationList = (params) => {
  return axios
    .post(`${base}/sku/options`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 商品 — 规格值保存
export const commoditySpecificationValueAdd = (params) => {
  return axios
    .post(`${base}/sku/optionsValue/add`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 运费模版列表
export const commodityShippingTemplateList = (params) => {
  return axios
    .post(`${base}/shippingTemplate/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 保存
export const commoditySave = (params) => {
  return axios
    .post(`${base}/commodity/saveOrUpdate`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品 — 详情
export const commodityDetail = (params) => {
  return axios
    .post(`${base}/commodity/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
//  商品 — 类目 — 列表
export const commodityCategoryList = (params) => {
  return axios
    .post(`${base}/commodity/categoryList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
//  商品 — 类目 — 标签 - 列表
export const commodityCategoryLabelList = (params) => {
  return axios
    .post(`${base}/commodity/categoryLabelList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
//  商品名列表
export const commodityNameList = (params) => {
  return axios
    .post(`${base}/commodity/commodityNameList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

//  商品 - 仓库列表
export const commodityOptionWarehouseList = (params) => {
  return axios
    .post(`${base}/option/warehouseList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
//  商品 - 产地列表
export const commodityOptionRegionList = (params) => {
  return axios
    .post(`${base}/option/regionList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
//  商品 - 税率列表
export const commodityOptionRateList = (params) => {
  return axios
    .post(`${base}/option/rateList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 商品 - 韩币汇率
export const commodityGetLatestRate = (params) => {
  return axios
    .get(`${base}/commodity/getLatestRate`, {
      params: params,
      headers: getPDFHeader(),
    })
    .then((res) => res);
};

// 关联商品 — 筛选条件
export const commodityFilterOptions = (params) => {
  return axios
    .post(`${base}/commodity/commodityOptions`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 关联商品 — 筛选列表
export const commodityFilterList = (params) => {
  return axios
    .post(`${base}/commodity/commodityList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理商列表
export const agentCompanylistAll = (params) => {
  return axios
    .post(`${base}/agent/listAll`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品列表
export const commodityListAll = (params) => {
  return axios
    .post(`${base}/commodity/listAll`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 添加商品专链-添加
export const commodityAgentAdd = (params) => {
  return axios
    .post(`${base}/commodityAgent/add`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 商品专链 - 列表
export const commodityLinkList = (params) => {
  return axios
    .get(`${base}/commodityAgent/pageList`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品专链接-修改
export const commodityAgentUpdateById = (params) => {
  return axios
    .put(`${base}/commodityAgent/updateById`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 商品专链 - 详情  /getDetails/{id}
export const commodityAgentDetail = (params) => {
  return axios
    .get(`${base}/commodityAgent/getDetails/${params.id}`, {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 商品专链 - 详情列表 /commodityAgent/getOrderListByAgentId
export const commodityAgentOrderListByAgentId = (params) => {
  return axios
    .get(`${base}/commodityAgent/getOrderListByAgentId`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 组件管理
 *======================================================================================*/
// 组件 - 关联商品下拉列表
export const moduleSelectCommodityList = (params) => {
  return axios
    .post(`${base}/module/commodityList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件、活动 - 关联商品列表
export const moduleCommodityList = (params) => {
  return axios
    .post(`${base}/module/module/commodity`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件、活动 - 列表
export const moduleList = (params) => {
  return axios
    .post(`${base}/module/module/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件、活动 - 排序
export const moduleComponentSort = (params) => {
  return axios
    .post(`${base}/module/module/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件下商品 - 排序
export const moduleCommoditySort = (params) => {
  return axios
    .post(`${base}/module/commoditySort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 类目 - 排序
export const moduleCategorySort = (params) => {
  return axios
    .post(`${base}/module/category/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件 - 回显
export const moduleDetail = (params) => {
  return axios
    .post(`${base}/module/module/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件 - 保存
export const moduleSave = (params) => {
  return axios
    .post(`${base}/module/module/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件 - 删除
export const moduleDelete = (params) => {
  return axios
    .post(`${base}/module/module/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 活动 - 保存
export const moduleActivitySave = (params) => {
  return axios
    .post(`${base}/module/sales/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 活动 - 回显
export const moduleActivityDetail = (params) => {
  return axios
    .post(`${base}/module/sales/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 活动 - 展示管理
export const moduleActivityShow = (params) => {
  return axios
    .post(`${base}/module/sales/show`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 组件、活动 - 关联商品解除
export const moduleCommodityDelete = (params) => {
  return axios
    .post(`${base}/module/module/release`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 组件 - 商品类目 - 列表
export const moduleCategoryList = (params) => {
  return axios
    .post(`${base}/module/category/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 商品类目 - 详情
export const moduleCategoryDetail = (params) => {
  return axios
    .post(`${base}/module/category/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 商品类目 - 上下线、删除
export const moduleCategoryUpdateStatus = (params) => {
  return axios
    .post(`${base}/module/category/updateStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 商品类目 - 修改或保存
export const moduleCategorySave = (params) => {
  return axios
    .post(`${base}/module/category/saveOrUpdate`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 商品类目 - 关联的商品列表
export const moduleCategoryCommodityList = (params) => {
  return axios
    .post(`${base}/module/category/commodityList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 组件 - 商品类目 - 解除商品关联
export const moduleCategoryCommodityDelete = (params) => {
  return axios
    .post(`${base}/module/category/commodityDelete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 服务管理模块
 *======================================================================================*/
// 服务管理 - 服务预约 - 列表
export const serviceOrdersList = (params) => {
  return axios
    .post(`${base}/shop_service/orderList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
export const serviceOrdersCancel = (params) => {
  return axios
    .post(`${base}/service_orders/cancel`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
export const serviceOrdersDetail = (params) => {
  return axios
    .post(`${base}/service_orders/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
export const serviceOrdersUpdateOrderInfo = (params) => {
  return axios
    .post(`${base}/service_orders/updateOrderInfo`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
export const serviceChatsList = (params) => {
  return axios
    .post(`${base}/chats/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
export const serviceChatsSave = (params) => {
  return axios
    .post(`${base}/chats/save`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
export const serviceChatsDelete = (params) => {
  return axios
    .post(`${base}/chats/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
export const serviceChatsGetSchedule = (params) => {
  return axios
    .post(`${base}/chats/getSchedule`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
export const serviceChatsAddSchedule = (params) => {
  return axios
    .post(`${base}/chats/addScheduleInfo`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 会员管理 - 详情 - 服务订单明细
export const serviceUserDetails = (params) => {
  return axios
    .post(`${base}/shop_service/userOrders`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};

// 服务管理 - 服务设置 - 列表
export const serviceManageList = (params) => {
  return axios
    .post(`${base}/shop_service/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 列表 - 排序
export const serviceManageListSort = (params) => {
  return axios
    .post(`${base}/shop_service/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 详情
export const serviceManageDetail = (params) => {
  return axios
    .post(`${base}/shop_service/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 新增、编辑
export const serviceManageSaveOrUpdate = (params) => {
  return axios
    .post(`${base}/shop_service/saveOrUpdate`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 改库存
export const serviceManageUpdateStock = (params) => {
  return axios
    .post(`${base}/shop_service/updateStock`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 改价
export const serviceManageUpdatePrice = (params) => {
  return axios
    .post(`${base}/shop_service/updatePrice`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 上架、下架
export const serviceManageUpDown = (params) => {
  return axios
    .post(`${base}/shop_service/upDown`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 删除
export const serviceManageDelete = (params) => {
  return axios
    .post(`${base}/shop_service/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 服务设置 - 置顶、取消置顶
export const serviceManageSort = (params) => {
  return axios
    .post(`${base}/shop_service/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 服务管理 - 门店信息 - 列表
export const serviceShopList = (params) => {
  return axios
    .post(`${base}/shop/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 服务管理 - 门店信息 - 新增、编辑
export const serviceShopSaveOrUpdate = (params) => {
  return axios
    .post(`${base}/shop/saveOrUpdate`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 服务管理 - 门店信息 - 启用、停用门店
export const serviceShopOpStatus = (params) => {
  return axios
    .post(`${base}/shop/opStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务管理 - 门店信息 - 删除门店
export const serviceShopDelete = (params) => {
  return axios
    .post(`${base}/shop/delete`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};

/**=====================================================================================
 * 登录模块 张起歌
 *======================================================================================*/
// 登录 - 检查手机号是否在库里
export const checkMobile = (params) => {
  return axios
    .post(`${base}/checkMobile`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 登录 - 发送短信验证码
export const verificationCode = (params) => {
  return axios
    .post(`${base}/mobile/send/verification/code`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 登录 - 验证短信验证码
export const checkVerificationCode = (params) => {
  return axios
    .post(`${base}/mobile/check/verification/code`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 登录 - auth登录  /api/qywx/oauth/exchange
export const exchange = (code) => {
  return axios
    .get(`${base}/qywx/oauth/exchange?code=${code}`)
    .then((res) => res.data);
};
// 登录 - 登录
export const login = (params) => {
  return axios
    .post(`${base}/login`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
//登录 获取扫码登录的二维码
export const oauth2AuthorizeUrl = (params) => {
  return axios
    .post(`${base}/qywx/oauth2AuthorizeUrl`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 查询是否已经扫码 /qywx/scanResult post 参数 state
export const scanResult = (params) => {
  return axios
    .post(`${base}/qywx/scanResult`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 登录 - 判断是否登陆过
export const isLogin = (params) => {
  return axios
    .post(`${base}/isLogin`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 登出 - 登出接口
export const logout = (params) => {
  return axios
    .post(`${base}/logout`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 登出 - 修改密码
export const updatePsd = (params) => {
  return axios
    .post(`${base}/update/psd`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 登出 - 验证密码
export const checkOldPassword = (params) => {
  return axios
    .post(`${base}/checkOldPassword`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 订单管理
 *======================================================================================*/
// 订单查询 - 列表
export const orderList = (params) => {
  return axios
    .post(`${base}/order/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 订单查询 - 导出
export const orderExport = (params) => {
  return axios
    .get(`${base}/order/export`, {
      params: params,
      headers: getHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};
// 订单查询 - 交易额 /order/listCount
export const orderListCount = (params) => {
  return axios
    .post(`${base}/order/listCount`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 详情
export const orderDetail = (params) => {
  return axios
    .post(`${base}/order/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 修改运费
export const orderFreightEdit = (params) => {
  return axios
    .post(`${base}/order/updateFreight`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 快递公司
export const orderDeliverCompany = (params) => {
  return axios
    .post(`${base}/order/deliver/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 发货
export const orderDeliver = (params) => {
  return axios
    .post(`${base}/order/deliver`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 取消订单/退款
export const cancelReturnOrder = (params) => {
  return axios
    .post(`${base}/order/refund`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 修改收货信息
export const editReceiveInfo = (params) => {
  return axios
    .post(`${base}/order/updateReceiveInfo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 订单查询 - 列表 - 下载PDF
export const orderDownloadPDF = (params) => {
  return axios
    .get(`${base}/order/download`, {
      params: params,
      headers: getPDFHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};
// 订单查询 - 服务订单 - 完成预约
export const serviceOrdersComplete = (params) => {
  return axios
    .post(`${base}/service_orders/complete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 添加返佣
export const addRebate = (params) => {
  return axios
    .get(`${base}/shop_service/addRebate`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 删除Na订单 DELETE  /shop_service/deleteServiceOrder  参数 id
export const deleteServiceOrder = (params) => {
  return axios
    .delete(`${base}/shop_service/deleteServiceOrder`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 评价管理 - 列表
export const commentList = (params) => {
  return axios
    .post(`${base}/comment/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 评价管理 - 回复
export const commentReply = (params) => {
  return axios
    .post(`${base}/comment/feedback`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 评价管理 - 删除
export const commentDelete = (params) => {
  return axios
    .post(`${base}/comment/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 运费模板 - 列表
export const expressList = (params) => {
  return axios
    .post(`${base}/shippingTemplate/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 运费模板 - 列表删除
export const expressListDelete = (params) => {
  return axios
    .post(`${base}/shippingTemplate/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 运费模板 - 详情
export const expressDetail = (params) => {
  return axios
    .post(`${base}/shippingTemplate/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 运费模板 - 新增/修改
export const expressUpdate = (params) => {
  return axios
    .post(`${base}/shippingTemplate/saveOrUpdate`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 运费模板 - 校验模板名是否重复
export const expressNameCheck = (params) => {
  return axios
    .post(`${base}/shippingTemplate/checkTemplateName`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 店铺管理
 *======================================================================================*/
// 店铺 - 组件设置 - 服务推荐 - 列表
export const shopComponentServiceRecommendList = (params) => {
  return axios
    .post(`${base}/recommended_service/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 组件设置 - 服务推荐 - 新增编辑
export const shopComponentServiceRecommendSaveOrUpdate = (params) => {
  return axios
    .post(`${base}/recommended_service/saveOrUpdateService`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 组件设置 - 服务推荐 - 详情
export const shopComponentServiceDetail = (params) => {
  return axios
    .post(`${base}/recommended_service/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 组件设置 - 服务推荐 - 列表排序
export const shopComponentServiceSort = (params) => {
  return axios
    .post(`${base}/recommended_service/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 组件设置 - 服务推荐 - 删除
export const shopComponentServiceDelete = (params) => {
  return axios
    .post(`${base}/recommended_service/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 店铺 - 广告管理 - 列表
export const shopPosterList = (params) => {
  return axios
    .post(`${base}/poster/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 店铺 - 广告管理 - 详情
export const shopPosterDetail = (params) => {
  return axios
    .post(`${base}/poster/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 广告管理 - 新增、编辑
export const shopPosterSaveOrUpdate = (params) => {
  return axios
    .post(`${base}/poster/saveOrUpdate`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 店铺 - 广告管理 - 上下线
export const shopPosterUpDown = (params) => {
  return axios
    .post(`${base}/poster/upDown`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 广告管理 - 删除
export const shopPosterDelete = (params) => {
  return axios
    .post(`${base}/poster/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 广告管理 - 排序
export const shopPosterSort = (params) => {
  return axios
    .post(`${base}/poster/sort`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};

// 店铺 - 详情页广告 - 列表
export const shopPosterPageList = (params) => {
  return axios
    .post(`${base}/poster_page/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 详情页广告 - 详情
export const shopPosterPageDetail = (params) => {
  return axios
    .post(`${base}/poster_page/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 详情页广告 - 新增编辑
export const shopPosterPageSaveOrUpdate = (params) => {
  return axios
    .post(`${base}/poster_page/saveOrUpdate`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 详情页广告 - 删除
export const shopPosterPageDelete = (params) => {
  return axios
    .post(`${base}/poster_page/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺 - 详情页广告 - 排序
export const shopPosterPageSort = (params) => {
  return axios
    .post(`${base}/poster_page/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 添加活动图片  /user/popup
export const addActivityPicture = (params) => {
  return axios
    .post(`${base}/user/popup`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};

// 查询活动图片列表  /user/popup/list
export const getActivityPictureList = (params) => {
  return axios
    .get(`${base}/user/popup/list`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 查询活动图片详情  /user/popup/{id}
export const getActivityPictureDetail = (id) => {
  return axios
    .get(`${base}/user/popup/${id}`, {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 更新活动图片内容  /user/popup/{id}
export const updateActivityPicture = (id, params) => {
  return axios
    .put(`${base}/user/popup/${id}`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};

// 删除活动图片  DELETE /user/popup/{id}
export const deleteActivityPicture = (id) => {
  return axios
    .delete(`${base}/user/popup/${id}`, {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 更新活动图片状态  PATCH /user/popup/{id}/status?status=1
export const updateActivityPictureStatus = (id, status) => {
  return axios
    .patch(`${base}/user/popup/${id}/status`, null, {
      params: { status: status },
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 广告管理 - 前台是否显示
export const shopAdvShowManage = (params) => {
  return axios
    .post(`${base}/media/adShow/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 首页广告/我的页面广告 - 编辑详情-关联商品接口(商品管理/商品管理列表)
export const shopCommodityList = (params) => {
  return axios
    .post(`${base}/commodity/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 首页广告/我的页面广告 - 编辑详情-关联类目(类目管理/类目管理列表)
export const shopCategoryList = (params) => {
  return axios
    .post(`${base}/module/category/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 -  删除
export const shopAdvPopWindowDelete = (params) => {
  return axios
    .post(`${base}/media/notice/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 -  上下线
export const shopAdvPopWindowUpdown = (params) => {
  return axios
    .post(`${base}/media/notice/updown`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 -  商品解除关联
export const shopAdvReleaseRelate = (params) => {
  return axios
    .post(`${base}/media/release/relate`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 弹窗广告-弹窗列表
export const shopAdvPopWindowList = (params) => {
  return axios
    .post(`${base}/media/notice/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 弹窗广告-编辑保存
export const shopAdvPopWindowManage = (params) => {
  return axios
    .post(`${base}/media/notice/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 弹窗广告-编辑详情
export const shopAdvPopWindowEcho = (params) => {
  return axios
    .post(`${base}/media/notice/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 首页广告列表
export const shopAdvBannerList = (params) => {
  return axios
    .post(`${base}/media/banner/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 首页广告-编辑保存
export const shopAdvBannerManage = (params) => {
  return axios
    .post(`${base}/media/banner/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 首页广告-编辑详情
export const shopAdvBannerEcho = (params) => {
  return axios
    .post(`${base}/media/banner/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 首页广告-排序
export const shopAdvBannerSort = (params) => {
  return axios
    .post(`${base}/media/banner/sort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 我的页面广告列表
export const shopMyPageList = (params) => {
  return axios
    .post(`${base}/media/myPage/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 我的页面广告列表-编辑保存
export const shopMyPageManage = (params) => {
  return axios
    .post(`${base}/media/myPage/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 我的页面广告列表-编辑详情
export const shopMyPageEcho = (params) => {
  return axios
    .post(`${base}/media/myPage/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 我的页面广告列表-礼包商品的列表
export const shopMyPageCommodity = (params) => {
  return axios
    .post(`${base}/media/myPage/choose`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 我的页面广告列表-当前id关联列表
export const shopMyPageCommodityList = (params) => {
  return axios
    .post(`${base}/media/myPage/commodity`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 商学院广告列表
export const shopBusinessTypeList = (params) => {
  return axios
    .post(`${base}/media/business/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 商学院广告列表-编辑保存
export const shopBusinessTypeManage = (params) => {
  return axios
    .post(`${base}/media/business/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 广告管理 - 商学院广告列表-编辑详情
export const shopBusinessTypeEcho = (params) => {
  return axios
    .post(`${base}/media/business/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 列表
export const hotTopicList = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 上下线
export const hotTopicUpDown = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/upDown`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 删除
export const hotTopicDetele = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/detele`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 编辑回显
export const hotTopicEcho = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 关联商品列表
export const hotTopicCommodity = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/commodity`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 解除关联
export const hotTopicRelease = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/release`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 编辑保存
export const hotTopicManage = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 热门搜索 - 列表排序
export const hotTopicCommoditySort = (params) => {
  return axios
    .post(`${base}/hot/hotTopic/commoditySort`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 分销商海报与介绍 - 回显
export const distributorIntroEcho = (params) => {
  return axios
    .post(
      `${base}/distributorIntro/distributorIntro/echo`,
      qs.stringify(params),
      { headers: getHeader() },
    )
    .then((res) => res.data);
};
// 分销商海报与介绍 - 编辑保存
export const distributorPosterManage = (params) => {
  return axios
    .post(
      `${base}/distributorIntro/distributorPoster/manage`,
      qs.stringify(params),
      { headers: getHeader() },
    )
    .then((res) => res.data);
};

/**=====================================================================================
 * 会员管理
 *======================================================================================*/
// 会员管理 - 等级设置 - 列表
export const userLevelList = (params) => {
  return axios
    .post(`${base}/user/levels`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 会员管理 - 等级设置 - 保存
export const userLevelSave = (params) => {
  return axios
    .post(`${base}/user/saveLevel`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};

// 用户管理 - 获取用户管理列表
export const userUserList = (params) => {
  return axios
    .post(`${base}/user/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 用户管理 - 用户详情
export const userUserDetail = (params) => {
  return axios
    .post(`${base}/user/detail`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 用户管理 - 刷新积分
// export const updatePoint = (params) => {
//   return axios
//     .get(`${base}/test/updatePoint`, qs.stringify(params), { headers: getHeader() })
//     .then((res) => res.data)
// }
export const updatePoint = (params) => {
  return axios
    .get(`${base}/test/updatePoint`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.status === 200);
};
// 用户管理 - 用户积分比例
export const getCurrentUserLevel = (params) => {
  return axios
    .post(`${base}/agent/getCurrentUserLevel`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 用户管理 - 启用停用
export const userUserUpdateStatus = (params) => {
  return axios
    .post(`${base}/user/updateStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 用户管理 - 修改收货地址
export const userUpdateAddress = (params) => {
  return axios
    .post(`${base}/user/updateAddress`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 用户管理 - 冻结、解冻账户或修改手机号
export const userUpdateStatusMobile = (params) => {
  return axios
    .post(`${base}/user/updateDistStatusOrMobile`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 用户管理 - 用户详情的订单列表
export const userOrderList = (params) => {
  return axios
    .post(`${base}/user/orderList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 用户、分销管理 - 获取用户列表
export const allUserList = (params) => {
  return axios
    .post(`${base}/user/all`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 用户 - 详情 - 积分统计
export const userPoints = (params) => {
  return axios
    .post(`${base}/user/points`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 用户 - 详情 - 积分明细
export const userDetailList = (params) => {
  return axios
    .post(`${base}/user/detail_list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 用户 - 详情 - 增加积分
export const agentSavePoints = (params) => {
  return axios
    .post(`${base}/agent/savePoints`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 用户 - 详情 - 录入积分
export const agentAdminAddPoint = (params) => {
  return axios
    .post(`${base}/agent/adminAddPoint`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 用户 - 详情 - 修改所属管家
export const updateUser = (params) => {
  return axios
    .post(`${base}/user/updateUser`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 用户 - 详情 - 获取管家列表
export const list = (params) => {
  return axios
    .post(`${base}/service_user/list`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 用户 - 详情 - 删除积分
export const agentDeletePoints = (params) => {
  return axios
    .post(`${base}/user/deletePoints`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 权限管理
 *======================================================================================*/
// 权限管理 - 角色权限 - 角色保存
export const permissionRoleSave = (params) => {
  return axios
    .post(`${base}/role/role/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 权限管理 - 角色权限 - 角色回显
export const permissionRoleDetail = (params) => {
  return axios
    .post(`${base}/role/role/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 权限管理 - 角色权限 - 列表
export const permissionRoleList = (params) => {
  return axios
    .post(`${base}/role/role/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 权限管理 - 角色权限 - 删除
export const permissionRoleDelete = (params) => {
  return axios
    .post(`${base}/role/role/delete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 员工管理 - 列表
export const staffList = (params) => {
  return axios
    .post(`${base}/role/crmUser/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 员工管理 - 新增/修改
export const staffUpdate = (params) => {
  return axios
    .post(`${base}/role/crmUser/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 员工管理 - 详情
export const staffDetail = (params) => {
  return axios
    .post(`${base}/role/crmUser/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 员工管理 - 编辑员工状态
export const staffStatusUpdate = (params) => {
  return axios
    .post(`${base}/role/crmUser/status`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 操作记录 - 列表
export const recordList = (params) => {
  return axios
    .post(`${base}/role/operationRecord/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 财务管理
 *======================================================================================*/
// 退款审核 - 列表
export const financialDepositList = (params) => {
  return axios
    .post(`${base}/finance/refund/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 退款审核 - 审核
export const financialDepositCheck = (params) => {
  return axios
    .post(`${base}/finance/refund/approve`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 兑换券核销 - 列表
export const financialCouponExchangeList = (params) => {
  return axios
    .post(`${base}/coupon/exchangeRecordList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 兑换券核销 - 已完成
export const financialCouponExchangeComplete = (params) => {
  return axios
    .post(`${base}/coupon/completeExchange`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 运营
 *======================================================================================*/
// 优惠券 - 新增
export const couponSaveUpdate = (params) => {
  return axios
    .post(`${base}/coupon/saveOrUpdate`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 优惠券 - 编辑详情
export const couponEditDetail = (params) => {
  return axios
    .post(`${base}/coupon/editDetail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 优惠券 - 列表
export const couponList = (params) => {
  return axios
    .post(`${base}/coupon/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 优惠券 - 详情
export const couponDetail = (params) => {
  return axios
    .post(`${base}/coupon/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 优惠券 - 状态设置（上下线）
export const couponChangeStatus = (params) => {
  return axios
    .post(`${base}/coupon/change`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 积分 - 列表
export const pointsList = (params) => {
  return axios
    .post(`${base}/points/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 积分 - 状态更改
export const pointsUpdateStatus = (params) => {
  return axios
    .post(`${base}/points/updateStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 积分 - 置顶
export const pointsSetTop = (params) => {
  return axios
    .post(`${base}/points/setTop`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 积分 - 积分商品保存
export const pointsSaveOrUpdateProduct = (params) => {
  return axios
    .post(`${base}/points/saveOrUpdate`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 积分 - 积分服务保存
export const pointsSaveOrUpdateService = (params) => {
  return axios
    .post(`${base}/points/saveOrUpdateService`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 积分 - 改库存
export const pointsUpdateStock = (params) => {
  return axios
    .post(`${base}/points/updateStock`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 积分 - 改积分
export const pointsUpdatePoints = (params) => {
  return axios
    .post(`${base}/points/updatePoints`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 秒杀 - 列表
export const marketingPromotionList = (params) => {
  return axios
    .post(`${base}/flashSale/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 秒杀 - 状态设置（上下线）
export const marketingPromotionStatusUpdate = (params) => {
  return axios
    .post(`${base}/flashSale/updateStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 秒杀 - 活动时段关联的商品列表
export const marketingPromotionCommodityList = (params) => {
  return axios
    .post(`${base}/flashSale/commodityList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 秒杀 - 编辑详情
export const marketingPromotionDetail = (params) => {
  return axios
    .post(`${base}/flashSale/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 秒杀 - 新增或修改
export const marketingPromotionSave = (params) => {
  return axios
    .post(`${base}/flashSale/saveOrUpdate`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};

// 满就送 - 列表
export const marketingGiftList = (params) => {
  return axios
    .post(`${base}/shipping/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 满就送 - 编辑
export const marketingGiftManage = (params) => {
  return axios
    .post(`${base}/shipping/manage`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 满就送 - 回显
export const marketingGiftEcho = (params) => {
  return axios
    .post(`${base}/shipping/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 满就送 - 上下线
export const marketingGiftUpdateStatus = (params) => {
  return axios
    .post(`${base}/shipping/status`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 输入校验、联想
 *======================================================================================*/
// 商品名列表
export const validGoodsList = (params) => {
  return axios
    .post(`${base}/commodity/commodityNameList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 校验商品名重复
export const validGoodsName = (params) => {
  return axios
    .post(`${base}/commodity/checkCommodityName`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 店铺字段验证
export const validShopProps = (params) => {
  return axios
    .post(`${base}/module/moduleCheck`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 关键词列表
export const validHotKeywordsList = (params) => {
  return axios
    .post(`${base}/hot/keyWordList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 代理
 *======================================================================================*/
// 代理 - 代理公司 - 列表
export const agentCompanyList = (params) => {
  return axios
    .post(`${base}/agent/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
//同步尘峰代理商 /test/taskSysnFriendSource
export const taskSysnFriendSource = (params) => {
  return axios
    .get(`${base}/test/taskSysnFriendSource`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 代理 - 尘峰
export const sourecList = (params) => {
  return axios
    .post(`${base}/sourec/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 关联代理 - 尘峰
export const affiliatedAgent = (params) => {
  return axios
    .post(`${base}/agent/affiliatedAgent `, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 新增、编辑
export const agentCompanySaveOrUpdate = (params) => {
  return axios
    .post(`${base}/agent/saveOrUpdate`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 删除
export const agentCompanyDelete = (params) => {
  return axios
    .post(`${base}/agent/removeAgent`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 启用、停用
export const agentCompanyOpStatus = (params) => {
  return axios
    .post(`${base}/agent/opStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 详情
export const agentCompanyDetail = (params) => {
  return axios
    .post(`${base}/agent/detail`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 详情 - 分销收益
export const agentCompanyDetailIncomeList = (params) => {
  return axios
    .post(`${base}/distributor/company/incomeList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 详情 - 提现列表
export const agentCompanyDetailWithdrawalList = (params) => {
  return axios
    .post(`${base}/agent/withdrawalList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 详情 - 提现列表 - 申请提现
export const agentCompanyDetailWithdrawal = (params) => {
  return axios
    .post(`${base}/agent/withdrawal`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 代理 - 服务分销 - 列表
export const agentServiceLevelList = (params) => {
  return axios
    .post(`${base}/agent/serviceLevels`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 服务分销 - 保存
export const agentServiceLevelSave = (params) => {
  return axios
    .post(`${base}/user/saveServiceLevel`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};

// 代理 - 商品分销 - 列表
export const agentGoodsLevelList = (params) => {
  return axios
    .post(`${base}/agent/productLevels`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 商品分销 - 保存
export const agentGoodsLevelSave = (params) => {
  return axios
    .post(`${base}/user/saveProductLevel`, params, { headers: getUtfHeader() })
    .then((res) => res.data);
};

// // 代理 - 服务分销 - 列表 (已废弃)
// export const agentServiceLevelList = params => {
//     return axios.post(`${base}/user/serviceLevels`, qs.stringify(params), { headers: getHeader() }).then(res => res.data);
// }
// // 代理 - 服务分销 - 保存 （已废弃）
// export const agentServiceLevelSave = params => {
//     return axios.post(`${base}/user/saveServiceLevel`, params, { headers: getUtfHeader() }).then(res => res.data);
// }

// // 代理 - 商品分销 - 列表 (已废弃)
// export const agentGoodsLevelList = params => {
//     return axios.post(`${base}/user/productLevels`, qs.stringify(params), { headers: getHeader() }).then(res => res.data);
// }
// // 代理 - 商品分销 - 保存 (已废弃)
// export const agentGoodsLevelSave = params => {
//     return axios.post(`${base}/user/saveProductLevel`, params, { headers: getUtfHeader() }).then(res => res.data);
// }

// 代理 - 员工管理 - 列表
export const agentEmployeeList = (params) => {
  return axios
    .post(`${base}/agent_employee/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 员工管理 - 新增、编辑
export const agentEmployeeSaveOrUpdate = (params) => {
  return axios
    .post(`${base}/agent_employee/saveOrUpdate`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 员工管理 - 启用、停用
export const agentEmployeeOpStatus = (params) => {
  return axios
    .post(`${base}/agent_employee/opStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 代理 - 公司代理 - 详情 - 分销收益 - 统计
export const agentIncome = (params) => {
  return axios
    .post(`${base}/agent/income`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 公司代理 - 详情 - 分销收益 - 服务订单总金额
export const agentServiceOrderStatics = (params) => {
  return axios
    .post(`${base}/agent/serviceOrderStatics`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 公司代理 - 详情 - 分销收益 - 商品订单总金额
export const agentProductOrderStatics = (params) => {
  return axios
    .post(`${base}/agent/productOrderStatics`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 公司代理 - 详情 - 分销收益 - 服务、商品订单
export const agentOrderList = (params) => {
  return axios
    .post(`${base}/agent/orderList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 公司代理 - 详情 - 员工排行
export const distributorSalesRank = (params) => {
  return axios
    .post(`${base}/distributor/salesRank`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理 - 代理公司 - 详情 - 员工
export const agentCompanyDetailEmployeeList = (params) => {
  return axios
    .post(`${base}/agent/employees`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 公司代理 - 详情 - 子代理排行
export const distributorChildAgentRank = (params) => {
  return axios
    .post(`${base}/distributor/childAgentRank`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 公司代理 - 详情 - 子代理
export const agentChildAgents = (params) => {
  return axios
    .post(`${base}/agent/childAgents`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 个人代理 - 详情 - 获取代理商下级顾客列表
export const agentCustomerList = (params) => {
  return axios
    .post(`${base}/agent/customerList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 个人代理 - 详情 - 获取项目/服务列表
export const agentServiceList = (params) => {
  return axios
    .post(`${base}/agent/serviceList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 代理管理 - 个人代理 - 详情 - 增加分销收益
export const agentSaveServiceIncome = (params) => {
  return axios
    .post(`${base}/agent/saveServiceIncome`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 个人代理 - 详情 - 删除分销收益
export const agentDistributorRemoveIncome = (params) => {
  return axios
    .post(`${base}/distributor/removeIncome`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 代理管理 - 个人代理 - 详情 - 下级顾客排行
export const agentCustomerListRank = (params) => {
  return axios
    .post(`${base}/agent/customerListRank`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 代理管理 - 提现
export const agentWithdrawalsSave = (params) => {
  return axios
    .post(`${base}/withdrawals/withdraw`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 用户服务等级 - 获取服务等级信息
export const userServiceLevel = (params) => {
  return axios
    .get(`${base}/user/serviceLevel`, { params: params, headers: getHeader() })
    .then((res) => res.data);
};
// 银行列表
export const bankList = (params) => {
  return axios
    .post(`${base}/bank/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};

// 财务管理 - 销售数据 - 统计
export const agentOrderStatics = (params) => {
  return axios
    .post(`${base}/agent/orderStatics`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 提现统计
export const distributorWithdrawStatistics = (params) => {
  return axios
    .post(`${base}/distributor/withdrawStatistics`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 财务管理 - 销售数据 - 订单列表
export const agentSaleOrderList = (params) => {
  return axios
    .post(`${base}/agent/saleOrderList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 财务管理 - 提现明细
export const agentWithdrawalsList = (params) => {
  return axios
    .post(`${base}/withdrawals/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 财务管理 - 提现明细 - 删除
export const agentWithdrawalsDelete = (params) => {
  return axios
    .delete(`${base}/withdrawals/delete/${params.id}`, {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 财务管理 - 提现明细 - 下载模板(服务)
export const downloadTemplate = (params) => {
  return axios
    .get(`${base}/withdrawals/downloadTemplate`, {
      params: params,
      headers: getHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};
// 财务管理 - 提现明细 - 上传模板(服务)
export const importExcel = (params) => {
  const formData = new FormData();
  if (params && params.file) {
    formData.append("file", params.file);
  }
  return axios
    .post(`${base}/withdrawals/importExcel`, formData, {
      headers: {
        Authorization:
          localStorage.getItem("crmUserToken") +
          "-" +
          localStorage.getItem("crmUserSid"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

// 财务管理 - 提现明细 - 下载模板(商品)
export const downloadOrderTemplate = (params) => {
  return axios
    .get(`${base}/withdrawals/downloadOrderTemplate`, {
      params: params,
      headers: getHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};
// 财务管理 - 提现明细 - 上传模板(商品)
export const orderImportExcel = (params) => {
  const formData = new FormData();
  if (params && params.file) {
    formData.append("file", params.file);
  }
  return axios
    .post(`${base}/withdrawals/orderImportExcel`, formData, {
      headers: {
        Authorization:
          localStorage.getItem("crmUserToken") +
          "-" +
          localStorage.getItem("crmUserSid"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

// 财务管理 - 提现明细 - 上传转账记录
export const agentWithdrawalsUpdateUrl = (params) => {
  return axios
    .post(`${base}/withdrawals/updateUrl`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

/**=====================================================================================
 * 分销
 *======================================================================================*/
// 分销管理列表
export const distributorCommissionList = (params) => {
  return axios
    .post(`${base}/distributor/commission/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 分销管理的回显
export const distributorCommissionEcho = (params) => {
  return axios
    .post(`${base}/distributor/commission/echo`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 获取分销的商品选择列表
export const distributorCommissionCommidityList = (params) => {
  return axios
    .post(
      `${base}/distributor/commission/commodity/list`,
      qs.stringify(params),
      { headers: getHeader() },
    )
    .then((res) => res.data);
};
// 分销管理的编辑
export const distributorCommissionManage = (params) => {
  return axios
    .post(`${base}/distributor/commission/manage`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 修改状态
export const distributorCommissionUpdateStatus = (params) => {
  return axios
    .post(
      `${base}/distributor/commission/update/status`,
      qs.stringify(params),
      { headers: getHeader() },
    )
    .then((res) => res.data);
};
// 分销商管理列表
export const distributorAgencyList = (params) => {
  return axios
    .post(`${base}/distributor/management/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 设置分销商的状态
export const distributorAgencyUpdateStatus = (params) => {
  return axios
    .post(`${base}/distributor/management/setStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 查看会员记录
export const distributorAgencyMember = (params) => {
  return axios
    .post(`${base}/distributor/management/memberRecord`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 查看订单列表
export const distributorAgencyOrder = (params) => {
  return axios
    .post(
      `${base}/distributor/management/distributor/orders`,
      qs.stringify(params),
      { headers: getHeader() },
    )
    .then((res) => res.data);
};
// 会员管理 - 会员详情 - 分销收益明细
export const distributorUserIncomeList = (params) => {
  return axios
    .post(`${base}/distributor/distributor/incomeList`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// 银行列表
export const distributionBankList = (params) => {
  return axios
    .post(`${base}/bank/list`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 银行编辑
export const distributionBankManage = (params) => {
  return axios
    .post(`${base}/bank/manage`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 上下架、删除银行
export const distributionBankUpdateStatus = (params) => {
  return axios
    .post(`${base}/bank/updateStatus`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 银行详情
export const distributionBankDetail = (params) => {
  return axios
    .post(`${base}/bank/detail`, qs.stringify(params), { headers: getHeader() })
    .then((res) => res.data);
};
// 提现明细
export const distributionWithdrawList = (params) => {
  return axios
    .post(`${base}/withdrawals/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 完成提现
export const distributionWithdrawComplete = (params) => {
  return axios
    .post(`${base}/withdrawals/complete`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};

// BI门店
export const BiShopList = (params) => {
  return axios
    .post(`${base}/shop/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// BI管家
export const BiServiceUserList = (params) => {
  return axios
    .post(`${base}/service_user/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// BI渠道
export const BiSourecList = (params) => {
  return axios
    .post(`${base}/sourec/list`, qs.stringify(params), {
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 服务看板接口
export const serviceOrderCount = (params) => {
  return axios
    .post(`${base}/dataBoard/serviceOrderCount`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 导出
// 服务看板接口
export const exportMultiSimple = (params) => {
  return axios
    .post(`${base}/dataBoard/exportMultiSimple`, params, {
      headers: getUtfHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};
// 新增目标 & 编辑
export const saveOrUpdateEmployeeAssessmentTarget = (params) => {
  return axios
    .post(`${base}/employeeAssessmentTarget/saveOrUpdate`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};

// 考核目标列表
export const employeeAssessmentTargetList = (params) => {
  return axios
    .post(
      `${base}/employeeAssessmentTarget/list?${qs.stringify(params)}`,
      null,
      {
        headers: getUtfHeader(),
      },
    )
    .then((res) => res.data);
};
// 下载业绩目标模板
export const employeeAssessmentTargetDownloadTemplate = (params) => {
  return axios
    .get(`${base}/employeeAssessmentTarget/downloadTemplate`, {
      params: params,
      headers: getHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};

// 导入业绩目标
export const employeeAssessmentTargetImportExcel = (params) => {
  const formData = new FormData();
  if (params && params.file) {
    formData.append("file", params.file);
  }
  return axios
    .post(`${base}/employeeAssessmentTarget/importExcel`, formData, {
      headers: {
        Authorization:
          localStorage.getItem("crmUserToken") +
          "-" +
          localStorage.getItem("crmUserSid"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
};

// 商品BI顶部卡片
export const orderCount = (params) => {
  return axios
    .post(`${base}/orderBoard/orderCount`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 商品BI顶部卡片2
export const orderCountDirectAndAgentSale = (params) => {
  return axios
    .post(`${base}/orderBoard/directAndAgentSale`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
//产品销量
export const commoditySale = (params) => {
  return axios
    .post(`${base}/orderBoard/commoditySale`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
//商品 渠道销量
export const channelSale = (params) => {
  return axios
    .post(`${base}/orderBoard/channelSale`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
//商品业绩对比表
export const serviceUserSale = (params) => {
  return axios
    .post(`${base}/orderBoard/serviceUserSale`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
// 商品导出
export const orderBoardExportMultiSimple = (params) => {
  return axios
    .post(`${base}/orderBoard/exportMultiSimple`, params, {
      headers: getUtfHeader(),
      responseType: "blob",
    })
    .then((res) => res);
};
// 券码列表
export const pointsItemsRoll = (params) => {
  return axios
    .get(`${base}/pointsItemsRoll/pageList`, {
      params: params,
      headers: getHeader(),
    })
    .then((res) => res.data);
};
// 券码核销
export const pointsItemsRollUse = (params) => {
  return axios
    .post(`${base}/pointsItemsRoll/updateById`, params, {
      headers: getUtfHeader(),
    })
    .then((res) => res.data);
};
